import { render, staticRenderFns } from "./AddServiceTypeDialog.vue?vue&type=template&id=2a8c6311&scoped=true"
import script from "./AddServiceTypeDialog.vue?vue&type=script&lang=js"
export * from "./AddServiceTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./AddServiceTypeDialog.vue?vue&type=style&index=0&id=2a8c6311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c6311",
  null
  
)

export default component.exports